import { Component, OnDestroy, OnInit, ElementRef, QueryList, ViewChildren, HostListener } from '@angular/core';
import { ModalDismissReasons, NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import * as fromEnums from 'projects/Autofacets-Core/src/app/utils/enums';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { UserDealersModel } from '../../business-entities/dealer-details.model';
import { StatusViewModel } from '../../business-entities/status-view-model';
import { UserRoleMenu } from '../../business-entities/user-role-menu.model';
import { DashboardService } from '../../business-services/dashboard.service';
import { DealerBusinessService } from '../../business-services/dealer.service';
import { SettingService } from '../../business-services/setting.service';
import { CultureLocaleService } from '../../services/culture-locale.service';
import { CustomPaggerService } from './../../../../../Autofacets-Core/src/app/common-services/custom-pagger.service';
import { NgbdSortableHeader, SortEvent } from './../../../../../Autofacets-Core/src/app/directives/sortable.directive';
import { NgbdModalContent } from './../../../../../Autofacets-Core/src/app/shared/delete-modal.component';
import { Constant } from './../../../../../Autofacets-Core/src/app/utils/constant';
import { DealerServiceRequestModel, DealerServiceViewModel } from './../../business-entities/dealer-service-view-model';
import { SelectListItemViewModel } from './../../business-entities/select-list-item-view-model';
import { DealerServiceBusinessService } from './../../business-services/dealer-service.service';
import { AddDealerServiceComponent } from './add-dealer-service/add-dealer-service.component';
import { EditDealerServiceComponent } from './edit-dealer-service/edit-dealer-service.component';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';


@Component({
  selector: 'app-dealer-service',
  templateUrl: './dealer-service.component.html',
})
export class DealerServiceComponent implements OnInit, OnDestroy {
  dealerServiceList: DealerServiceViewModel[];
  dealerList: Array<SelectListItemViewModel>;
  total$: Observable<number>;
  popupCloseResult = false;
  selectedDealerId: string = '';
  currentLanguage: string;
  paginationSub: Subscription;
  currentlagSub: Subscription;
  focus$ = new Subject<string>();
  userRoleRightsDetails: UserRoleMenu;
  isAdvanceSearch: boolean = false;
  needAttention : boolean = false;  
  displayPriceInWidget:boolean = false;
  isFixed : boolean = false; 
  isRecommended :boolean = false; 
  selectedStatus: number;
  StatusList: StatusViewModel[] = [];
  VATPercentage:number=0
  dealerServiceRequestModel: DealerServiceRequestModel = {
    isAdvanceSearch: false,
    statusId: 0,
    name: "",
    serviceNo: "",
    dealerName: "",
    description: "",
    serviceCategoryName: "",
    dealerId: "",
    language: "",
    isFromDropdown: false,
    isNeedAttention:false,
    isFixprice:false,
    isDiaplyPriceInWidget:false,
    isRecommendedService:false,
  };
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  constructor(
    public pService: CustomPaggerService,
    public dealerBusinessService: DealerBusinessService,
    public currentLanguageService: CurrentLanguage,
    private spinner: NgxSpinnerService,
    private dealerServiceBusinessService: DealerServiceBusinessService,
    private modalService: NgbModal,
    private translate: TranslateService,
    private cookieservice: CookieService,
    public settingService: SettingService,
    private userService: UserDataService,
    private _eref: ElementRef,
    private dashboardService: DashboardService,
    public cultureLocaleService: CultureLocaleService,
    config: NgbModalConfig,
    private secureStorage: SecureStorage
  ) {

    this.pService.pageSize = 10;
    this.pService.searchby = ['serviceNo', 'name', 'dealerName', 'description', 'serviceCategoryName'];
    this.pService.searchTerm = '';
    config.backdrop = 'static';
    config.keyboard = false;
  }

  ngOnInit() {
    if (this.dashboardService.isFromDashboard) {
      this.selectedStatus = fromEnums.StatusCode.Active;
    }
    this.StatusList = this.dashboardService.getStatusList();
    if (this.currentlagSub) {
      this.currentlagSub.unsubscribe();
    }
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === fromEnums.ModuleNames.DealerService);
    this.pService.dataSource = [];
    this.currentLanguage = this.cookieservice.get('userSelectedLanguage')
    this.getUserDealers();
    this.checkId();
    this.focus$.subscribe(x => {
      if (x.length === 0) {
        this.dealerServiceBusinessService.dealerId = '';
        this.currentlagSub = this.currentLanguageService.currentLanguage.subscribe(_x => {
          this.getDealerServiceList(this.dealerServiceRequestModel);
        });
      }
    });
    this.VATPercentage=this.secureStorage.getKeyData('VATPercentage');
  }

  @HostListener('document:click', ['$event'])
  onSearchBoxClose(event) {
    if (event && event.target.className.indexOf('ng-option') == -1) {
      if (!this._eref.nativeElement.getElementsByClassName('advanced-search-box')[0]?.contains(event.target)) {
        this.dealerServiceRequestModel.isAdvanceSearch = false;
      }
    }
  }
  onSearch() {
    this.dealerServiceRequestModel.isAdvanceSearch = true;
  }

  AdvanceSearchSubmit() {
    this.dealerServiceRequestModel.isAdvanceSearch = true;
    this.dealerServiceRequestModel.statusId = this.selectedStatus;
    this.dealerServiceRequestModel.isNeedAttention = this.needAttention;
    this.dealerServiceRequestModel.dealerId = this.selectedDealerId;
    this.dealerServiceRequestModel.isFixprice = this.isFixed;
    this.dealerServiceRequestModel.isRecommendedService = this.isRecommended;
    this.dealerServiceRequestModel.isDiaplyPriceInWidget = this.displayPriceInWidget;
    this.getDealerServiceList(this.dealerServiceRequestModel);
    this.dealerServiceRequestModel.isAdvanceSearch = false;

  }
  onReset() {
    this.dealerServiceRequestModel.isAdvanceSearch = false;
    this.selectedStatus = undefined;
    this.dealerServiceRequestModel.statusId = fromEnums.StatusCode.All;
    this.dealerServiceRequestModel.name = '';
    this.dealerServiceRequestModel.serviceNo = '';
    this.dealerServiceRequestModel.dealerName = '';
    this.dealerServiceRequestModel.dealerId = '';
    this.selectedDealerId = '';
    this.dealerServiceBusinessService.dealerId = '';
    this.dealerServiceRequestModel.description = '';
    this.dealerServiceRequestModel.serviceCategoryName = '';
    this.dealerServiceRequestModel.isNeedAttention = false;
    this.dealerServiceRequestModel.isFixprice = false;
    this.dealerServiceRequestModel.isDiaplyPriceInWidget = false;
    this.dealerServiceRequestModel.isRecommendedService = false;
    this.isRecommended = false;
    this.displayPriceInWidget = false;
    this.needAttention = false;
    this.isFixed = false;
    this.getDealerServiceList(this.dealerServiceRequestModel);
  }
  onClose() {
    this.onReset();
    this.dealerServiceRequestModel.isAdvanceSearch = false;
  }

  checkId() {
    if (this.dealerServiceBusinessService.isEdit && this.dealerServiceBusinessService.dealerId) {
      this.selectedDealerId = this.dealerServiceBusinessService.dealerId;
    }
    else {
      this.dealerServiceBusinessService.dealerId = '';
    }
    this.dealerServiceBusinessService.isEdit = false;
    this.dealerServiceBusinessService.dealerId = this.userService.currentUserValue.defaultDealerId;
    this.selectedDealerId = this.userService.currentUserValue.defaultDealerId;
    this.currentlagSub = this.currentLanguageService.currentLanguage.subscribe(_x => {
      this.getDealerServiceList(this.dealerServiceRequestModel);
    });
  }

  async getUserDealers() {
    await this.dealerBusinessService.getUserDealersDropdown().then((response) => {
      this.dealerList = this.mapdealer(response.userDealersModel);
      this.dealerBusinessService.dealerList = this.dealerList;
      if(this.dealerList.length===1)
      {
        this.selectedDealerId = response.userDealersModel[0].dealerId;
      }
    })
  }

  mapdealer(array: UserDealersModel[]) {
    let supperArray = [];
    if (array && array.length > 0) {
      array.forEach(element => {
        let single = Object();
        single.value = element.dealerId
        single.text = element.dealerName

        supperArray.push(single);
      })
    }
    return supperArray;
  }

  onDealerSelected(dealerId: string, flag: string) {
    this.selectedDealerId = dealerId;
    this.dealerServiceBusinessService.dealerId = dealerId;
    if (flag === 'dealerDropdown') {
      this.dealerServiceRequestModel.isAdvanceSearch = false;
      this.getDealerServiceList(this.dealerServiceRequestModel);
    }
    else {
      this.dealerServiceRequestModel.isAdvanceSearch = true;
    }
  }
  onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.pService.sortColumn = column;
    this.pService.sortDirection = direction;
  }

  ngOnDestroy(): void {
    if (this.paginationSub) {
      this.paginationSub.unsubscribe();
    }
    this.currentlagSub.unsubscribe();
    this.pService.dealers$ = new BehaviorSubject<any[]>([]);
    this.pService.total$ = new BehaviorSubject<number>(0);

  }

  async getDealerServiceList(dealerServiceRequestModel: DealerServiceRequestModel) {
    this.spinner.show();
    dealerServiceRequestModel.dealerId = this.dealerServiceBusinessService.dealerId;
    dealerServiceRequestModel.language = this.cookieservice.get('userSelectedLanguage');
    dealerServiceRequestModel.isFromDropdown = false;
    await this.dealerServiceBusinessService.getDealerServiceList(dealerServiceRequestModel).then((response) => {
      this.pService.dataSource = response.dealerServiceList;
      if (response.dealerServiceList.length !== 0) {
        this.paginationSub = this.pService.dealers$.subscribe(result => {
          this.dealerServiceList = this.dealerServiceDataMapper(result);
        });
      }
    });
    this.spinner.hide();

  }

  private dealerServiceDataMapper(service: DealerServiceViewModel[]) {
    let supperArray = [];
    if (service && service.length > 0) {
      for (let index = 0; index < service.length; index++) {
        const element = service[index];
        const single = Object();
        single.rowNumber = this.currentPageNumber(index);
        single.id = element.id;
        single.dealerName = element.dealerName;
        single.name = element.name;
        single.duration = element.duration;
        single.price = element.price;
        single.priceInclVAT = Utility.GetPriceInludingVAT(element.price,this.VATPercentage).toString();
        single.description = element.description;
        single.isActive = element.isActive;
        single.isRecommended = element.isRecommended;
        single.serviceCategoryId = element.serviceCategoryId;
        single.logo = element.logo;
        single.isDisplayPriceInWidget = element.isDisplayPriceInWidget;
        single.serviceCategoryName = element.serviceCategoryName;
        single.dealerId = element.dealerId;
        single.serviceId = element.serviceId;
        single.needAttention = element.needAttention;
        single.serviceNo = element.serviceNo;
        supperArray.push(single);
      }
    }
    return supperArray;
  }

  onAdd() {
    this.dealerServiceBusinessService.dealerList = this.dealerList;
    const modalref = this.modalService.open(AddDealerServiceComponent, { size: 'lg', windowClass: 'EditPopup' });
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    });
  }

  editDealerService(dealerService: DealerServiceViewModel) {
    this.dealerServiceBusinessService.dealerServiceDetails = dealerService;
    this.dealerServiceBusinessService.dealerId = this.selectedDealerId;
    const modalref = this.modalService.open(EditDealerServiceComponent, { size: 'lg', windowClass: 'EditPopup' });
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    });
  }

  deleteDealerService(id: number) {
    let modelHeadermsg = this.translate.instant("lblDelete");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"), this.translate.instant("lblDealerService"), true);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        this.dealerServiceBusinessService.deleteDealerService(id).then((response) => {
          if (response.responseCode === Constant.SuccessResponseCode) {
            this.currentlagSub = this.currentLanguageService.currentLanguage.subscribe(_x => {
              this.getDealerServiceList(this.dealerServiceRequestModel);
            });
          }
        });
      }
    });
  }
  changeNeedAttention(event: Event) {
    this.needAttention = (event.target as HTMLInputElement).checked;
    this.dealerServiceRequestModel.isNeedAttention = this.needAttention;
  }
  OnChangeClick(event: Event) {
    this.isFixed = (event.target as HTMLInputElement).checked;
    this.dealerServiceRequestModel.isFixprice = this.isFixed;
  }
  DisplayPriceInWidget(event: Event) {
    this.displayPriceInWidget = (event.target as HTMLInputElement).checked;
    this.dealerServiceRequestModel.isDiaplyPriceInWidget = this.displayPriceInWidget;
  }
  changeRecommendedService(event: Event){
    this.isRecommended = (event.target as HTMLInputElement).checked;
    this.dealerServiceRequestModel.isRecommendedService = this.isRecommended;
  }
  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
  private currentPageNumber(cIndex: number): number {
    let rtPageNumber = 0;
    if (this.pService.page === 1) {
      rtPageNumber = cIndex + 1;
    }
    else if (this.pService.page > 1) {
      rtPageNumber = Number.parseInt(`${(this.pService.pageSize * (this.pService.page - 1))}`) + (cIndex + 1);
    }
    return rtPageNumber;
  }
}

